import { TypedTypePolicies } from '~/graphql/generated/type-policies';

const typePolicies: TypedTypePolicies = {
  Answer: {
    fields: {
      values: { merge: false },
    },
  },
  // Policy objects are embedded inside Assessment results with per-assessment
  // filtered controlBundleList arrays (each assessment uses a different subset
  // of the same policy's control bundles). With default normalization Apollo
  // merges all Policy objects sharing the same _id into a single cache entry,
  // causing the last-written controlBundleList to overwrite the others. This
  // makes the Policy Compliance Risk donut show incorrect control counts on
  // fresh page loads. Disabling normalization stores each Policy inline so
  // every assessment keeps its own correctly filtered controlBundleList.
  Policy: {
    keyFields: false,
  },
  OrganizationBranding: {
    keyFields: false,
    merge: true,
  },
  // Prevent Apollo from normalizing mutation response types
  AssessmentUpdateSummary: {
    keyFields: false,
  },
  AnswerBundleUpdateSummary: {
    keyFields: false,
  },
  Query: {
    fields: {},
  },
};

export default typePolicies;
